import {
  GET_INSTANCE_CONFIG_REQUEST,
  GET_INSTANCE_CONFIG_SUCCESS,
  GET_INSTANCE_CONFIG_FAILURE
 } from '../constants'
import Api from '../services/api.js'

export function getInstanceConfigRequest(){
  return {
    type: GET_INSTANCE_CONFIG_REQUEST
  }
}

export function getInstanceConfigSuccess(data){
  return {
    type: GET_INSTANCE_CONFIG_SUCCESS,
    data: data,
  }
}

export function getInstanceConfigFailure(exception){
  return {
    type: GET_INSTANCE_CONFIG_FAILURE,
    exception: exception
  }
}

export function getInstanceConfig() {
  return dispatch => {
    dispatch(getInstanceConfigRequest())
    const api = new Api();
    return api.get("/__api/v1/instance_config")
    .then(response => {
      dispatch(getInstanceConfigSuccess(response.data))
    })
    .catch(error => dispatch(getInstanceConfigFailure(error)));
  }
}



// WEBPACK FOOTER //
// ./src/actions/instance.js